<template>
    <div>
        <UserProfile/>
    </div>
</template>
<script>
    import UserProfile from '@/components/users/UserProfile';

    export default {
        name: 'profile',
        components: {
            UserProfile,
        }
    }
</script>